import { DeliveryPromise } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/homeDelivery/components/deliveryPromise";
import { MinimumOrderQuantity } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/homeDelivery/components/minimumOrderQuantity";
import { SupplierInfoLink } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/homeDelivery/components/supplierInfoLink";
import { Base } from "@/components/Product/ECommerce/components/delivery/components/deliveryTypes/deliveryItem/components/homeDelivery/homeDelivery.base";

export const HomeDelivery = Object.assign(Base, {
    DeliveryPromise: DeliveryPromise,
    MinimumOrderQuantity: MinimumOrderQuantity,
    SupplierInfoLink: SupplierInfoLink
});
